<template>
  <div>
    <search ref="searchForm" :searchForm="searchForm" :loading="loading"
            :stationsForSelect="stationsForSelect"
            :operatorTree="operatorTree"
            :appointStateForSelect="appointStateForSelect"
            @operatorSelect="operatorSelect"
            @submitForm="getData"></search>
    <el-table :data="tableData" stripe style="width: 100%" ref="recordTable" border
              v-loading="loading">
      <af-table-column prop="appointOrderNo"  label="预约订单号"></af-table-column>
      <af-table-column prop="operatorName" label="运营商"></af-table-column>
      <af-table-column prop="stationName" label="站点"></af-table-column>
      <af-table-column prop="gunCode" label="枪编号"></af-table-column>
      <af-table-column prop="customerPhone" label="客户手机号"></af-table-column>
      <!--<af-table-column prop="appointOvertime" label="预约提前时间量"></af-table-column>-->
      <!--<af-table-column prop="requestSource.message" label="预约来源">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.requestSource.message }} &lt;!&ndash; 预约中，黄色 &ndash;&gt;
          </el-tag>
        </template>
      </af-table-column>-->
      <af-table-column  prop="appointStateCode" label="预约状态">
        <template slot-scope="scope">
          <el-tag :style="{color: '#fff', backgroundColor: '#fbbd08', borderColor: '#fbbd08'}" v-if="scope.row.appointStateCode === 0">
            {{ scope.row.appointState.message }} <!-- 预约中，黄色 -->
          </el-tag>
          <el-tag :effect="scope.row.cencelTypeCode === 0?'light':'dark'"  v-else-if="scope.row.appointStateCode === 1">
            {{ scope.row.cencelType.message }} <!-- 撤销 双蓝 -->
          </el-tag>
          <el-tag :type="tagType(scope.row)" effect="dark" v-else>
            {{ scope.row.appointState.message }} <!-- 其他 -->
          </el-tag>
        </template>
      </af-table-column>

      <af-table-column prop="appointCreateTime" label="创建时间"></af-table-column>
      <af-table-column prop="appointCencelTime" label="结束时间"></af-table-column>
      <!--<el-table-column prop="groupName" label="绑定集团"></el-table-column>-->
      <!--<el-table-column prop="createTime" label="创建时间" :formatter="dateFormatter"></el-table-column>-->
      <af-table-column label="操作" width="240px" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" plain type="danger" @click="openCancel(scope.row)"
                     v-if="checkPermission(['bee:res:appoint:cencelAppoint']) && scope.row.appointStateCode === 0">取消预约
          </el-button>
          <el-button size="mini" plain @click="detail(scope.$index, scope.row)">
            详情
          </el-button>
          <!--<el-button size="mini" plain type="danger" @click="delete(scope.$index, scope.row)"-->
                     <!--v-if="checkPermission(['bee:res:car:deleteCar'])">删除-->
          <!--</el-button>-->
        </template>
      </af-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :child-msg="pageParam" @callFather="getData"></Pagination>
    <Detail
      :visible="detailVisible"
      :detail-form="selectRowData"
      @close="closeDialog"
    ></Detail>
    <Cancel
      :visible="cancelVisible"
      :loading="cancelLoading"
      :id="cancelId"
      @close="closeDialog"
      @submit="cancel"
    ></Cancel>
  </div>
</template>

<script>
  import Search from '@/module/resourceCenter/page/appointmentManager/appointmentRecords/search'
  import appointApi from "../../../api/appointmentApi";
  import commonApi from "../../../api/commonApi";
  import Pagination from "../../../../../components/Pagination";
  import Detail from './detail'
  import Cancel from './cancel'
  export default {
    name: "list",
    components: {
      Search,
      Pagination,
      Detail,
      Cancel
    },
    data() {
      return {
        searchForm: {},
        loading: false,
        tableData: [],
        selectRowData: {},
        detailVisible: false,
        cancelVisible: false,
        cancelId: 0,
        cancelLoading: false,
        appointStateForSelect: [],
        operatorTree: [], // 运营商树
        stationsForSelect: [],
        // 分页参数
        pageParam: {
          t: {},
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
      }
    },
    computed: {
      tagType() {
        return function(row) {
          switch (row.appointStateCode) {
            case 2: return 'danger'
            case 3: return 'warning'
            case 4: return 'success'
            case 5: return 'info'
          }
        }
      }
    },
    methods: {
      getData() {
        this.$refs.searchForm.$children[0].validate((valid) => {
          if (!valid) {
            return;
          }
          this.loading = true
          this.pageParam.t = this.searchForm
          let param = Object.assign({}, this.pageParam)
          console.log(param)
          appointApi.getAppointRecords(param).then((res) => {
            if (res.code === 0) {
              this.pageParam.total = res.data.total
              this.tableData = res.data.list
            } else {
              this.$message.error(res.message)
            }
            this.loading = false
          })
        })
      },
      openCancel(row) {
        this.cancelVisible = true
        this.cancelId = row.id
      },
      cancel(form) {
        this.$confirm('确认取消该预约吗？', '提示', {}).then(() => {
          this.cancelLoading = true
          appointApi.cancelAppoint(form).then((res) => {
            this.cancelLoading = false
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: 'success'
              })
              this.cancelVisible = false
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(_ => {
        })
      },
      // 详情
      detail(index, row) {
        this.loadSelectItem();
        if (row !== undefined) {
          this.selectRowData = Object.assign({}, row)
          this.detailVisible = true
        }
      },
      // 删除
      delete(index, row) {
        this.$confirm('确定要删除：' + row.license + '吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            let param = {id: row.id}
            appointApi.deleteCar(param).then((res) => {
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.getData()
              } else {
                this.$message.error(res.message)
              }
              this.loading = false
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
      // 日期格式化
      dateFormatter(row, column) {
        let datetime = row.createTime+"";
        return datetime.substring(0,10)
      },
      // 加载下拉框
      loadSelectItem() {
        let operatorId = this.$store.getters.operatorIds
        commonApi.stationsForSelectByOperatorId(operatorId).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data;
          }
        });
        // 运营商下拉框
        commonApi.getOperatorsTree().then((res) => {
          if (res.code === 0) {
            this.operatorTree = res.data;
          }
        });
        // 预约订单状态下拉框
        appointApi.appointStateForSelect().then((res)=> {
          if(res.code === 0) {
            this.appointStateForSelect = res.data.appointOrderStateEnum
          }
        })
      },
      operatorSelect(val) {
        commonApi.stationsForSelectByOperatorId([val]).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data
          }
        })
      },
      // 根据运营商id匹配名字
      formatOperator: function (row, column) {
        let obj = this.operatorForSelect.find((item) => {
          return item.id === row.operatorId
        });
        if (obj != null && obj !== undefined) {
          return obj.name
        } else {
          return row.operatorId
        }
      },
      // 关闭弹框
      closeDialog(type) {
        // console.log('type:' + type)
        if (type === 'detail') {
          this.detailVisible  = false
        }else if(type === 'cancel') {
          this.cancelVisible  = false
        }
      },
    },

    created: function () {
      this.loadSelectItem();
    },
    mounted: function () {
      this.getData()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentRecords/list.vue